import React from "react";

export default function StepTick() {
  return <div>✓</div>;
}
